export enum UsersTableStaticActionType {
  Delete = 'delete',
}
